// extracted by css-extract-rspack-plugin
export default {"workspaceItem":"vI9tY"};